module.exports = __webpack_public_path__ + "img/asus-zenfone-zooms.496a2b96.jpg";